module.exports = __webpack_public_path__ + "24d0b561622d004c499fea5cdc813504.fbx";